import React, { useState } from "react";
import { Button, Grid } from "@mui/material";
import { Nullable } from "../../@typings/typings";
import { DefaultExtensionType, defaultStyles, FileIcon } from "react-file-icon";

interface ImageUploadProps {
	editorName: string;
	onLoad: (files: FileList) => Promise<void>;
}

export default function ImageUpload({ editorName, onLoad }: ImageUploadProps) {
	const [files, setFiles] = useState<Nullable<FileList>>(null);

	return (
		<Grid container alignItems={"center"} item columnSpacing={2}>
			<Grid item>
				<label htmlFor={"btn-upload" + editorName}>
					<input
						id={"btn-upload" + editorName}
						style={{ display: "none" }}
						type="file"
						accept="image/*"
						onChange={(_) => setFiles(_.target.files)}
					/>
					<Button size={"small"} variant={"outlined"} component="span">
						Выберите файл
					</Button>
				</label>
			</Grid>
			<Grid item>
				<Button size={"small"} color="primary" variant="contained" disabled={!files} onClick={() => onLoad(files!)}>
					Загрузить
				</Button>
			</Grid>
			{files && files.length > 0 ? (
				<>
					<Grid item sx={{ width: "48px", boxSizing: "border-box" }}>
						<FileIcon
							extension={files[0].name.split(".").pop()}
							{...defaultStyles[files![0].name.split(".").pop() as DefaultExtensionType]}
						/>
					</Grid>
					<Grid item>{files[0].name}</Grid>
				</>
			) : null}
		</Grid>
	);
}
